import {
  ChimesModeMap,
  ChimesSchemeMap,
  CreateChannelPlaceholder,
  DecimalCoordinates,
  RelayCoordinates,
  RelayTimeValue
} from "./MainPage.model";
import { RELAY_MODE, RelayModeValue } from "../RelaySettings/RelaySettings.model";

export const createChannelPlaceholder: CreateChannelPlaceholder = (channel) => ({
  channel,
  hours: 0,
  minutes: 0,
  amperage: undefined,
  state: 0,
  timeChanged: false,
  enabled: true,
});

export const formatDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

export const formatTimeOnly = (date: Date): string => {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

export const getChimesSchemeText = (scheme?: number | null): string => {
  const schemes: ChimesSchemeMap = {
    0: 'Куранты на Спасской башне Московского Кремля',
    1: 'Куранты Сергиево-троицкая Лавра',
    2: 'Лондонский Биг Бен',
    3: 'Напольные часы',
    4: 'Псково-Печерский монастырь',
    5: 'Проигрыш и бой (без четвертей)',
    6: 'Проигрыш и бой',
    7: 'Проигрыш и бой (без четвертей)',
    8: 'Проигрыш и бой (без четвертей)',
    9: 'Проигрыш и бой (без четвертей)',
    10: 'Уникальная программа',
  };

  return schemes[scheme ?? -1] || 'Куранты Московского Кремля';
};

export const getChimesModeText = (mode?: number | null): string => {
  const modes: ChimesModeMap = {
    0: 'Боя нет',
    1: 'Только в 12',
    2: 'Только в 12 и 18',
    3: 'Каждый час',
    4: 'Каждые полчаса',
    5: 'Каждые 15 минут',
    6: 'Только бой',
  };

  return modes[mode ?? -1] || '';
};

export const convertCoordinatesToDecimal = (
  coordinates?: RelayCoordinates | null
): DecimalCoordinates | null => {
  if (!coordinates) return null;

  try {
    const latDegrees = parseInt(coordinates.latitude.substring(0, 3), 10);
    const latMinutes = parseInt(coordinates.latitude.substring(3), 10) / 10000;
    const latitude = latDegrees + latMinutes / 60;
    const finalLat = coordinates.latitudeDirection === 'S' ? -latitude : latitude;

    const lonDegrees = parseInt(coordinates.longitude.substring(0, 3), 10);
    const lonMinutes = parseInt(coordinates.longitude.substring(3), 10) / 10000;
    const longitude = lonDegrees + lonMinutes / 60;
    const finalLon = coordinates.longitudeDirection === 'W' ? -longitude : longitude;

    return {
      lat: finalLat,
      lng: finalLon,
    };
  } catch (error) {
    console.error('Ошибка преобразования координат:', error);
    return null;
  }
};

export const formatTime = (timeObj?: RelayTimeValue | string | null) => {
  if (!timeObj) {
    return "--:--";
  }

  if (typeof timeObj === 'string') {
    return timeObj;
  }

  if (timeObj.hours === undefined || timeObj.minutes === undefined) {
    return "--:--";
  }

  const hours = timeObj.hours.toString().padStart(2, '0');
  const minutes = timeObj.minutes.toString().padStart(2, '0');

  return `${hours}:${minutes}`;
};

export const getRelayModeText = (mode?: RelayModeValue) => {
  if (!mode) {
    return "";
  }

  return RELAY_MODE[mode] || "";
};
